class GeneralExportHelperClass {
  addStatusToRequest(statusSpecifier, statusView, request = []) {
    const isMultiStatus = Array.isArray(statusView);
    if (statusView) {
      if (!isMultiStatus) {
        request.push(`${statusSpecifier}=${statusView}`);
      }
      if (isMultiStatus) {
        request.push(`${statusSpecifier}=${statusView.join(`&${statusSpecifier}=`)}`);
      }
    }
  }

  addExtraParamsToRequest(extraParams, request = []) {
    if (extraParams) {
      extraParams.forEach((reqParam) => {
        request.push(
          ...Object.keys(reqParam).map((key) => {
            // strip off quotes
            const reqValue = encodeURIComponent(
              typeof reqParam[key] === 'string' ? reqParam[key].replace(/^"(.*)"$/, '$1') : reqParam[key],
            );
            return `${key}=${reqValue}`;
          }),
        );
      });
    }
  }
}

export const GeneralExportHelper = new GeneralExportHelperClass();
